import { render } from "./AdmCard.vue?vue&type=template&id=a7bda4bc&scoped=true"
import script from "./AdmCard.vue?vue&type=script&lang=js"
export * from "./AdmCard.vue?vue&type=script&lang=js"

import "./AdmCard.vue?vue&type=style&index=0&id=a7bda4bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7bda4bc"]])

export default __exports__